import { Action, ThunkAction } from '@reduxjs/toolkit'

import store from './index'

export enum AsyncStateStatus {
    INITIAL = 'INITIAL',
    LOADING = 'LOADING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
}

/**
 * Paginator interface
 */
export interface IPaginator {
    rows: number
    page: number
}

/**
 * Search interface
 */
export interface IFilter {
    startDate: string
    endDate?: string
}


export type ApplicationState = ReturnType<typeof store.getState>

export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, ApplicationState, unknown, Action<string>>
